import { FC, memo, Fragment } from 'react'
import styled from 'styled-components'

import { ScrollContainer } from '@app/ui'
import { ListElement } from './ListElement'
import { ListElementProps } from './types'

type ListStyle = Partial<{
        height: string
      }>

type ListProps = {
    style?: Partial<{
      list: ListStyle
    }>
    elements: ListElementProps[];
}

const List: FC<ListProps> = ({
  elements,
  style = {}
}) => {
  const { list = {} } = style

  return (
    <StyledScrollContainer {...list} >
      {elements.map((element) => <Fragment key={element.id}><ListElement
        id={element.id}
        ctaType={element.ctaType}
        title={element.title}
        ctaTitle={element.ctaTitle}
        caption={element.caption}
        image={element.image}
        onSelectElement={element.onSelectElement}
        otherElementData={element.otherElementData}/></Fragment>)}
    </StyledScrollContainer>
  )
}

const StyledScrollContainer = styled.div<ListStyle>`
  background-color: white;
  padding: 0 25px;
  display: flex;
  overflow-y: scroll;
  flex-direction: column;
  gap: 5px;
  height: ${props => props.height};
  -ms-overflow-style: scrollbar; 

  &::-webkit-scrollbar {
    width: 6px; 
    background-color: white;
  }
  
  &::-webkit-scrollbar-thumb {
    background-color: #d0d0d0;
    border-radius: 3px;
    margin-right: 2px;
  }
`

export default memo(List)
